// extracted by mini-css-extract-plugin
export default {"receiptPage":"ReceiptPage_receiptPage__zfGpM","address":"ReceiptPage_address__zTsrI","coin":"ReceiptPage_coin__oN9fQ"};